export default __webpack_public_path__ + "static/media/bottling.ff2b5f83.jpg";